import { lazy } from 'react';

import { LayoutTypes, Urls } from '#constants';

export const ROUTES = [
  {
    component: lazy(() => import('./LoginPage')),
    id: 1,
    path: Urls.LoginPage,
    protected: false,
    roles: ['client', 'clientAgent', 'trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./OutcomePage')),
    id: 2,
    layout: LayoutTypes.Base,
    path: Urls.OutcomePage,
    protected: true,
    roles: ['client', 'clientAgent', 'trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./IncomePage')),
    id: 3,
    layout: LayoutTypes.Base,
    path: Urls.IncomePage,
    protected: true,
    roles: ['client', 'clientAgent', 'trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./ProfilePage')),
    id: 4,
    layout: LayoutTypes.Base,
    path: Urls.Profile,
    protected: true,
    roles: ['client', 'clientAgent', 'trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./OperatorsPage')),
    id: 5,
    layout: LayoutTypes.Base,
    path: Urls.Operators,
    protected: true,
    roles: ['trader']
  },
  {
    component: lazy(() => import('./CardsPage')),
    id: 6,
    layout: LayoutTypes.Base,
    path: Urls.Cards,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./TariffsPage')),
    id: 7,
    layout: LayoutTypes.Base,
    path: Urls.Tariffs,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./BanksPage')),
    id: 8,
    layout: LayoutTypes.Base,
    path: Urls.Banks,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./DevicesPage')),
    id: 9,
    layout: LayoutTypes.Base,
    path: Urls.Devices,
    protected: true,
    roles: ['trader']
  },
  {
    component: lazy(() => import('./HoldersPage')),
    id: 10,
    layout: LayoutTypes.Base,
    path: Urls.Holders,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./CorrectionsPage')),
    id: 11,
    layout: LayoutTypes.Base,
    path: Urls.Corrections,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./CorrectionPage')),
    id: 12,
    layout: LayoutTypes.Base,
    path: Urls.Corrections + '/new',
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./CorrectionPage')),
    id: 13,
    layout: LayoutTypes.Base,
    path: Urls.Corrections + '/:id',
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./DebtorsPage')),
    id: 14,
    layout: LayoutTypes.Base,
    path: Urls.Debtors,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./StatisticsPage')),
    id: 15,
    layout: LayoutTypes.Base,
    path: Urls.Statistic,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./CardStatementPage')),
    id: 16,
    layout: LayoutTypes.Base,
    path: Urls.CardStatement,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./CardStatementPage')),
    id: 17,
    layout: LayoutTypes.Base,
    path: `${Urls.CardStatement}/:id`,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./GreyListPage')),
    id: 18,
    layout: LayoutTypes.Base,
    path: `${Urls.GreyList}`,
    protected: true,
    roles: ['trader', 'traderAgent']
  },
  {
    component: lazy(() => import('./BlackListPage')),
    id: 19,
    layout: LayoutTypes.Base,
    path: `${Urls.BlackList}`,
    protected: true,
    roles: ['trader', 'traderAgent']
  }
];
